import { RecordModificationsComponent } from './operations/record-modifications/record-modifications.component';
import { OperationsComponent } from './operations/operations.component';
import { SidebarOperationsComponent } from './home/sidebar/sidebar-operations.component';
import { SidebarReportingComponent } from './home/sidebar/sidebar-reporting.component';
import { LoggedOutComponent } from './authentication/loggedout/loggedout.component';
import { DisplayCurveComponent } from './market-data/curve/display-curve.component';
import { CanDeactivateGuard } from './common/guard/can-deactivate.guard';
import { CashFlowTableComponent } from './trade/cash-flow/cash-flow-table/cash-flow-table.component';
import { AliasService } from './alias/alias.service';
import { MomentPipe } from './common/moment.pipe';
import { ManualCorrectionComponent } from './correction/manual-correction/manual-correction.component';
import { ThroughputComponent } from './survival-horizon/throughput/throughput.component';
import { LocalDBService } from './service/local-db.service';
import { BufferComponent } from './buffer/buffer.component';
import { BalanceMetricComponent } from './metrics/balance-metric/balance-metric.component';
import { MultiEntityNostroDetailsComponent } from './survival-horizon/multi-entity-nostro-details/multi-entity-nostro-details.component';
import { FiveDayLadderComponent } from './survival-horizon/five-day-ladder/five-day-ladder.component';
import { IntradayLadderService } from './survival-horizon/intraday-ladder/intraday-ladder.service';
import { CorrectionComponent } from './correction/correction.component';

import { SurvivalHorizonComponent } from './survival-horizon/survival-horizon.component';
import { ApplicationConfigurationService } from './application-configuration/application-configuration.service';
import { ExplainService } from './explain/explain.service';
import { ProjectionComponent } from './projection/projection.component';
import { MarketDataService } from './market-data/market-data.service';
import { AlertMessageService } from './alert/alert-message/alert-message.service';
import { SurvivalHorizonService } from './survival-horizon/survival-horizon.service';
import { DashboardEventService } from './dashboard/dashboard-event.service';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy, DatePipe, DecimalPipe } from '@angular/common';
import { AppRoutes } from './app.routes';

import { APP_INITIALIZER, ErrorHandler } from '@angular/core';




import { AppConfig } from './app.config';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HomeSideBarComponent } from './home/home.sidebar.component';
import { HomeSidebarTabComponent } from './home/home.sidebartabcontent.component';
import { SidebarSHComponent } from './home/sidebar/sidebar-sh.component';
import { SidebarRiskComponent } from './home/sidebar/sidebar-risk.component';
import { SidebarALMComponent } from './home/sidebar/sidebar-alm.component';
import { HomeTopBarComponent } from './home/home.topbar.component';
import { HomeFooterComponent } from './home/home.footer.component';
import { TrendMetricComponent } from './metrics/trend-metric/trend-metric.component';
import { SnapshotService } from './snapshot/snapshot.service';
import { ServiceRegistry } from './service/service-registry.service';

import { SHLadderComponent } from './survival-horizon/s-h-ladder/s-h-ladder.component';
import { SHCompareLadderComponent } from './survival-horizon/s-h-ladder/s-h-compare-ladder.component';
import { AmountCellComponent } from './common/amount-cell/amount-cell.component';
import { AlertComponent } from './alert/alert.component';
import { AlertMessageComponent } from './alert/alert-message/alert-message.component';
import { MetricBarComponent } from './metrics/metric-bar.component';
import { TDCellDirective } from './common/cell/td-cell.directive';
import { MarketDataComponent } from './market-data/market-data.component';
import { DetailPlaceholderComponent } from './detail/detail-placeholder/detail-placeholder.component';
import { DetailDirective } from './detail/detail.directive';
import { DetailComponent } from './detail/detail.component';
import { ExplainComponent } from './explain/explain.component';
import { CompareExplainComponent } from './explain/compare-explain.component';
import { ExplainTablesComponent } from './explain/explain-tables.component';
import { AlertSummaryComponent } from './alert/alert-summary/alert-summary.component';
import { HistoComponent } from './histo/histo.component';
import { ApplicationConfigurationComponent } from './application-configuration/application-configuration.component';
import { AlertMetricComponent } from './metrics/alert-metric/alert-metric.component';
import { AlertTableComponent } from './alert/alert-table.component';
import { TimeDurationPipe } from './common/time-duration.pipe';
import { NegativeParenthesesPipe } from './common/negative-parentheses.pipe';
import { AccountBalanceComponent } from './account-balance/account-balance.component';
import { AccountBalanceService } from './account-balance/account-balance.service';
import { BreachMetricComponent } from './metrics/breach-metric/breach-metric.component';
import { ProjectionMetricComponent } from './metrics/projection-metric/projection-metric.component';
import { CorrectionService } from './correction/correction.service';
import { CommunicationService } from './common/communication.service';
import { ProjectionUpdateComponent } from './correction/projection-update/projection-update.component';
import { ProjectionService } from './projection/projection.service';
import { AccountBalanceAdjustmentComponent } from './correction/account-balance-adjustment/account-balance-adjustment.component';
import { SwitchDateComponent } from './profile/switch-date/switch-date.component';
import { SwitchProfileComponent } from './profile/switch-profile/switch-profile.component';
import { NostroLadderComponent } from './survival-horizon/nostro-ladder/nostro-ladder.component';
import { LoroLadderComponent } from './survival-horizon/loro-ladder/loro-ladder.component';
import { SignificantLadderComponent } from './survival-horizon/significant-ladder/significant-ladder.component';
import { ReplayControllerComponent } from './survival-horizon/replay-controller/replay-controller.component';
import { ForeignOutflowMetricComponent } from './metrics/foreign-outflow-metric/foreign-outflow-metric.component';
import { ThroughputMetricComponent } from './metrics/throughput-metric/throughput-metric.component';
import { SuspenseBalanceMetricComponent } from './metrics/suspense-balance-metric/suspense-balance-metric.component'
import {
    SuspenseBalanceDetailsComponent
} from './metrics/suspense-balance-metric/suspense-balance-details/suspense-balance-details.component'
import { ForeignOutflowDetailsComponent } from './metrics/foreign-outflow-metric/foreign-outflow-details/foreign-outflow-details.component';

import { EodComponent } from './eod/eod.component';
import { ReferenceTimeControllerComponent } from './survival-horizon/reference-time-controller/reference-time-controller.component';
import { IntradayLadderComponent } from './survival-horizon/intraday-ladder/intraday-ladder.component';
import { TransactionDetailComponent } from './transaction/transaction-detail/transaction-detail.component';
import { TransactionTableComponent } from './transaction/transaction-table/transaction-table.component';
import { SearchBarComponent } from './common/search-bar/search-bar.component';
import { TransactionSearchComponent } from './transaction/transaction-search/transaction-search.component';
import { AuthenticationModule } from './authentication/authentication.module';
import { UIModule } from './common/ui.module';
import { RiskModule } from './risk-manager/risk.module';
import { ALMModule } from './alm/alm.module';

// import { HeartbeatMetricComponent } from './metrics/heartbeat-metric/heartbeat-metric.component';

export function loadConfig(config: AppConfig) {
    return () => config.load();
}

@NgModule({
    imports: [
        BrowserModule,
        AppRoutes,
        HttpClientModule,
        BrowserAnimationsModule,
        AuthenticationModule,
        UIModule,
        RiskModule,
        ALMModule,
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        LoggedOutComponent,
        HomeSideBarComponent,
        HomeSidebarTabComponent,
        SidebarSHComponent,
        SidebarRiskComponent,
        SidebarALMComponent,
        SidebarReportingComponent,
        SidebarOperationsComponent,
        HomeTopBarComponent,
        HomeFooterComponent,
        TrendMetricComponent,
        SHLadderComponent,
        SHCompareLadderComponent,
        AmountCellComponent,
        AlertComponent,
        AlertMessageComponent,
        MetricBarComponent,
        TDCellDirective,
        MarketDataComponent,
        ProjectionComponent,
        DetailPlaceholderComponent,
        DetailDirective,
        DetailComponent,
        ExplainComponent,
        CompareExplainComponent,
        ExplainTablesComponent,
        SurvivalHorizonComponent,
        AlertSummaryComponent,
        HistoComponent,
        ApplicationConfigurationComponent,
        AlertMetricComponent,
        AlertTableComponent,
        TimeDurationPipe,
        NegativeParenthesesPipe,
        CorrectionComponent,
        AccountBalanceComponent,
        BreachMetricComponent,
        ProjectionMetricComponent,
        ProjectionUpdateComponent,
        AccountBalanceAdjustmentComponent,
        SwitchDateComponent,
        SwitchProfileComponent,
        NostroLadderComponent,
        LoroLadderComponent,
        SignificantLadderComponent,
        FiveDayLadderComponent,
        ReplayControllerComponent,
        ForeignOutflowMetricComponent,
        ThroughputMetricComponent,
        SuspenseBalanceMetricComponent,
        SuspenseBalanceDetailsComponent,
        ForeignOutflowDetailsComponent,
        EodComponent,
        ReferenceTimeControllerComponent,
        IntradayLadderComponent,
        MultiEntityNostroDetailsComponent,
        BalanceMetricComponent,
        // HeartbeatMetricComponent,
        BufferComponent,
        ThroughputComponent,
        ManualCorrectionComponent,
        TransactionDetailComponent,
        TransactionTableComponent,
        MomentPipe,
        SearchBarComponent,
        TransactionSearchComponent,
        CashFlowTableComponent,
        DisplayCurveComponent,
        OperationsComponent,
        RecordModificationsComponent,
    ],
    providers: [
        // { provide: ErrorHandler, useClass: LiquiticsErrorHandler},
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        AppConfig,
        { provide: APP_INITIALIZER, useFactory: loadConfig, deps: [AppConfig], multi: true },
        CanDeactivateGuard,
        CommunicationService,
        DatePipe,
        DecimalPipe,
        TimeDurationPipe,
        NegativeParenthesesPipe,
        SnapshotService,
        ServiceRegistry,
        ApplicationConfigurationService,
        DashboardEventService,
        SurvivalHorizonService,
        AlertMessageService,
        MarketDataService,
        ExplainService,
        AccountBalanceService,
        CorrectionService,
        ProjectionService,
        IntradayLadderService,
        LocalDBService,
        MomentPipe,
        AliasService,
    ],
    entryComponents: [
        DetailPlaceholderComponent,
        ExplainComponent,
        HistoComponent,
        SurvivalHorizonComponent,
        CorrectionComponent,
        ProjectionUpdateComponent,
        AccountBalanceAdjustmentComponent,
        SwitchDateComponent,
        SwitchProfileComponent,
        ManualCorrectionComponent,
        TransactionDetailComponent,
        TransactionSearchComponent,
        DisplayCurveComponent,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
